//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "marionette",
  "messaging/messenger",
  "./kbRoleHistoryModalView",
  "modules/shared/sortableList/sortableListModule",
], function (Marionette, Messenger, KbRoleHistoryModalView, SortableListModule) {
  "use strict";

  var KbRoleHistoryModalController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "kbRoleHistoryModal";
    },
    show: function (kbRole) {
      this.layout = new KbRoleHistoryModalView.kbRoleHistoryModalLayout({ model: kbRole });
      var headers = Messenger.reqres.request("kbRole:history:headers");
      this.kbRoleHistoryList = this.addSubModule(
        new SortableListModule({
          region: this.layout.kbRoleHistory,
          headers: headers,
          recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
          namespace: "kbRoleHistory",
        }),
      );

      this.layout.on(
        "done",
        function () {
          Messenger.vent.trigger("close:modal");
        },
        this,
      );

      this.layout.on(
        "show",
        function () {
          this._showSubViews(kbRole);
        },
        this,
      );

      this.showRegion(this.layout);

      this.kbRole = kbRole;
    },
    _showSubViews: function (kbRole) {
      this.kbRoleHistoryList.show(kbRole.history());
    },
  });

  return KbRoleHistoryModalController;
});
